import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Grid, Card } from "@material-ui/core";
import {
  ProfileContentLeft,
  ProfileContentRight,
} from "../../components/profile-content";
import { MainContext } from "../../context/main";
import { getUpdateUser, uploadfile } from "../../apis/user";
import { useSnackbar } from "notistack";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
  },
  container: {
    height: `calc(100% - ${theme.spacing(-2)}px)`,
  },
  content: { height: "100%", width: "100%" },
}));

const Profile = () => {
  const classes = useStyle();
  const [process, setprocess] = useState(true);
  const [fetch, setfetch] = useState(false);
  const { userInfo, setuserInfo } = useContext(MainContext);
  const { enqueueSnackbar } = useSnackbar();
  const [image, setImage] = useState("");
  const [upimage, setupimage] = useState("");
  const [user, setUser] = useState([
    { title: "Name", name: "name", value: "" },
    { title: "Lastname", name: "lastname", value: "" },
    { title: "Phone", name: "phone", value: "" },
    { title: "Organization", name: "organization", value: "" },
    { title: "Address", name: "address", value: "" },
    { title: "District", name: "district", value: "" },
    { title: "Subdistrict", name: "subdistrict", value: "" },
    { title: "City", name: "city", value: "" },
    { title: "Country", name: "country", value: "" },
    { title: "Zip Code", name: "zipcode", value: "" },
  ]);

  const onChangeUser = (e: any, index: any) => {
    const formvalue = [...user];
    formvalue[index].value = e.target.value;
    setUser(formvalue);
    setprocess(false);
  };

  const onCancel = () => {
    setfetch(false);
    setprocess(true);
    setupimage("");
  };

  const onUpdate = async () => {
    let img = "";

    if (upimage !== "") {
      const upload = await uploadfile(upimage);
      if (upload.status.code === 200) {
        img = upload.data[0].file;
      } else {
      }
    }

    let input = {
      first_name: user[0].value,
      last_name: user[1].value,
      phone: user[2].value,
      organization: user[3].value,
      address: user[4].value,
      amphoe: user[5].value,
      tambon: user[6].value,
      province: user[7].value,
      country: user[8].value,
      zipcode: user[9].value,
      role: userInfo?.role,
      enabled: true,
      profile_picture: img !== "" ? img : userInfo?.profile_picture,
    };
    const update = await getUpdateUser(userInfo?.id, input);
    if (update.status.code === 200) {
      setuserInfo({
        first_name: user[0].value,
        last_name: user[1].value,
        phone: user[2].value,
        organization: user[3].value,
        address: user[4].value,
        amphoe: user[5].value,
        tambon: user[6].value,
        province: user[7].value,
        country: user[8].value,
        zipcode: user[9].value,
        role: userInfo?.role,
        id: userInfo?.id,
        email: userInfo?.email,
        profile_picture: img !== "" ? img : userInfo?.profile_picture,
        mea: userInfo?.mea,
        google: userInfo?.google,
      });

      setfetch(false);
      setprocess(true);

      enqueueSnackbar("User profile Saved.", {
        variant: "success",
      });
    } else {
      enqueueSnackbar("Opp!! Something wrong.", {
        variant: "error",
      });
    }
  };

  const onSetData = useCallback(() => {
    setUser([
      {
        title: "Name",
        name: "name",
        value: userInfo ? String(userInfo.first_name) : "",
      },
      {
        title: "Lastname",
        name: "lastname",
        value: userInfo ? String(userInfo.last_name) : "",
      },
      {
        title: "Phone",
        name: "phone",
        value: userInfo ? (userInfo.phone ? String(userInfo.phone) : "") : "",
      },
      {
        title: "Organization",
        name: "organization",
        value: userInfo
          ? userInfo.organization
            ? String(userInfo.organization)
            : ""
          : "",
      },
      {
        title: "Address",
        name: "address",
        value: userInfo
          ? userInfo.address
            ? String(userInfo.address)
            : ""
          : "",
      },
      {
        title: "District",
        name: "district",
        value: userInfo ? (userInfo.amphoe ? String(userInfo.amphoe) : "") : "",
      },
      {
        title: "Subdistrict",
        name: "subdistrict",
        value: userInfo ? (userInfo.tambon ? String(userInfo.tambon) : "") : "",
      },
      {
        title: "City",
        name: "city",
        value: userInfo
          ? userInfo.province
            ? String(userInfo.province)
            : ""
          : "",
      },
      {
        title: "Country",
        name: "country",
        value: userInfo
          ? userInfo.country
            ? String(userInfo.country)
            : ""
          : "",
      },
      {
        title: "Zip Code",
        name: "zipcode",
        value: userInfo
          ? userInfo.zipcode
            ? String(userInfo.zipcode)
            : ""
          : "",
      },
    ]);

    setImage(
      userInfo
        ? userInfo.profile_picture
          ? String(userInfo.profile_picture)
          : ""
        : ""
    );
  }, [userInfo]);

  useEffect(() => {
    if (!fetch) {
      onSetData();
      setfetch(true);
    } else {
    }
  }, [fetch, onSetData]);

  const onChangeImage = (e: any) => {
    setImage(URL.createObjectURL(e.target.files[0]));
    setupimage(e.target.files[0]);
    setprocess(false);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={2} className={classes.container}>
        <Fragment>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Card className={classes.content}>
              <ProfileContentLeft
                onChangeImage={onChangeImage}
                imagefile={image}
              />
            </Card>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
            <Card className={classes.content}>
              <ProfileContentRight
                usersData={user}
                onChangeUser={onChangeUser}
                process={process}
                onCancel={onCancel}
                onUpdate={onUpdate}
              />
            </Card>
          </Grid>
        </Fragment>
      </Grid>
    </div>
  );
};

export default Profile;
